console.warn = ()=> {}

import * as THREE from 'three'
window.THREE = THREE
require('three/examples/js/loaders/OBJLoader')
require('three/examples/js/loaders/MTLLoader')
require('three/examples/js/loaders/ColladaLoader')
require('three/examples/js/loaders/collada/Animation.js')
require('three/examples/js/loaders/collada/AnimationHandler.js')
require('src/lib/KeyFrameAnimation.js')

require('src/lib/Maf')
require('whatwg-fetch')
window._ = require('lodash')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import {sync} from 'vuex-router-sync'

sync(store, router)

Vue.config.productionTip = false

// SHARE
// require('src/api/ShareService.js')

// ANALYTICS
// require('src/api/AnalyticsService.js')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})


store.dispatch('browser/getCountry')
// store.dispatch('browser/checkAudio')


// DEBUG
window.Vue = Vue
window.store = store
window.router = router
window.i18n = i18n



// WEBPACK FOOTER //
// ./src/main.js